import React from 'react';
import ReactPlayer from 'react-player/youtube';

export default function BannerVideo({ data }) {
  const { banner, categoria } = data;

  return (
    <div className='container mb-8 md:mb-12'>
      <h3 className='video-title text-gray-600 mb-3'>{categoria.descripcion}</h3>

      <div className='banner-container'>
        <ReactPlayer
          className='react-player'
          config={{
            youtube: {
              playerVars: { showinfo: 0 },
            },
          }}
          url={banner[0].url}
          width='100%'
          height='450px'
        />

        {(banner[0].title || banner[0].description) &&
          (banner[0].title !== ' ' || banner[0].description !== ' ') && (
            <div className='video-card-info flex justify-between p-3'>
              <div className='banner_info-title'>{banner[0].title}</div>
              <div className='banner_info-description'>{banner[0].description}</div>
            </div>
          )}
      </div>
    </div>
  );
}
